import { render } from "./parametrage.vue?vue&type=template&id=648a5db0"
import script from "./parametrage.vue?vue&type=script&lang=ts"
export * from "./parametrage.vue?vue&type=script&lang=ts"
script.render = render

export default script